// import { Outlet } from "react-router-dom";
// import SideMenu from "./SideMenu";
// import Messagedialogbox from "./Messagedialogbox";
// function ProtectedRoute() {
//   return (
//     <div className="jb_app">
//       <SideMenu />
//       <main>
//         <Outlet />
//       </main>
//       <Messagedialogbox />
//     </div>
//   );
// }
// export default ProtectedRoute;


import { Outlet } from "react-router-dom";
import { useState } from "react";
import SideMenu from "./SideMenu";
import Messagedialogbox from "./Messagedialogbox";
import HideSettings from "./HideSettings";

function ProtectedRoute() {
  const [showHidePanel, setShowHidePanel] = useState(false);

  return (
    <div className="jb_app">
      <SideMenu
        showHidePanel={showHidePanel}
        onOpenHide={() => setShowHidePanel(true)}
        onCloseHide={() => setShowHidePanel(false)}
      />
      <main>
        {showHidePanel ? (
          <HideSettings onClose={() => setShowHidePanel(false)} />
        ) : (
          <Outlet />
        )}
      </main>
      <Messagedialogbox />
    </div>
  );
}

export default ProtectedRoute;